import { PropsWithChildren, Suspense } from 'react';
import styled from 'styled-components';

import { lazy } from 'lib/retry';

const Root = styled.div`
  position: relative;
  isolation: isolate;
`;
const ShaderWrapper = styled.div`
  position: absolute;
  inset: 0;
`;

const Shader = lazy(async () =>
  import('@sorare/trois/src/components/FireBackground').then(module => ({
    default: module.FireBackground,
  }))
);

export const FireBackground = ({
  children,
  ...rest
}: PropsWithChildren<React.JSX.IntrinsicElements['div']>) => {
  return (
    <Root {...rest}>
      <ShaderWrapper>
        <Suspense fallback={null}>
          <Shader fallback={null} />
        </Suspense>
      </ShaderWrapper>
      {children}
    </Root>
  );
};
